import * as v from 'valibot';

export const StructuredContentDocumentSchema = v.object({
  type: v.string(),
  version: v.string(),
  props: v.looseObject({}),
  useLearnContentOverrides: v.optional(v.boolean()),
});
